import Cookies from "js-cookie";
import { SIGN_UP } from "../../../../../config/Endpoints.js";
import { postApi } from "../../../../utils/api.ts";
import { useSqeOnboardingApi } from "../../onboarding/sqe/sqe-onboarding-link-context.tsx";
import { SQE_ONBOARDING } from "../../onboarding/sqe/sqe-onboarding-api.ts";

export function useCreateEmployeeSignup() {
  const isSqe = useSqeOnboardingApi();
  const signup = async (payload: Record<string, unknown>): Promise<void> => {
    await postApi(isSqe ? `${SQE_ONBOARDING}/signup` : SIGN_UP, isSqe ? undefined : Cookies.get("accessToken"), payload as Record<string, unknown>);
  };

  return { signup };
}
